module.exports = __webpack_public_path__ + "img/sx.a7248001.svg";